@use '../../../design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .itemRow {
    padding: 8px;
  }

  .addColumnTableHeader {
    padding: 0;
    position: sticky;
    right: 0;
    z-index: calc(var(--z-index-smarttable-sticky-header-cell) + 2);

    > span {
      justify-content: flex-end;
      margin-right: 2px;
    }
  }

  .searchInput {
    padding: 8px;
    border-bottom: 1px solid var(--border-soft);
    margin-bottom: 4px;

    [data-input-wrapper] {
      padding: 8px;
    }
  }

  .dropdownCheckbox {
    label {
      width: 100%;
      align-items: center;

      [data-checkmark] {
        margin-top: 0;
      }
    }
  }

  .columnsDropdown {
    background-color: var(--surface-default);
    border: 1px solid var(--border-soft);
    border-radius: border-radius(r1);
    box-shadow: var(--elevation-moderate);

    [data-dropdown-list] {
      border: none;
    }
  }
}
